/**
    * Food description
    * (c) lg2fabrique 2017
*/
import { Cavalefringale } from './Cavalefringale';
import { Assets } from '../core/Assets';
import { autobind } from 'frontools/decorators/Autobind';
import GameTimer from '../core/components/GameTimer';
import { GameEvent } from '../core/GameAbstract';
import NumberUtils from 'frontools/utils/NumberUtils';
import ComponentAbstract from '../core/components/ComponentAbstract';

export class Food extends ComponentAbstract {
    
    public static CLICKED_FOOD              : string                    = "FOOD_CLICKED";
    public static LIMIT_FOOD                : string                    = "LIMIT_FOOD";
    public static TRIGGER_NEW_ONE           : string                    = "NEW_ONE";
    
    private _game                           : Cavalefringale            = Cavalefringale.instance;

    private _container                      : PIXI.Container;
    private _sprite                         : PIXI.extras.AnimatedSprite;
    private _foodNumber                     : number;
    private _walkingIndex                   : number;

    private _tween                          : TweenMax;
    private _speed                          : number;
    
    private _clicked                        : boolean                   = false;
    private _score                          : number;

    constructor(foodNumber:number, speed:number, sound:number,) {
        super();

        this._foodNumber = foodNumber;
        this._speed = speed;
        let walkFrames = [];

        switch (this._foodNumber) {
            case 1 : 
                this._sprite = Assets.getSpriteFromJson('cupcake');
                this._walkingIndex = 9;
                this._score = 3;
                break;
            case 2 : 
                this._sprite = Assets.getSpriteFromJson('hamburger'); 
                this._walkingIndex = 10;
                this._score = 2;
                break;
            case 3 : 
                this._sprite = Assets.getSpriteFromJson('taco'); 
                this._walkingIndex = 11;
                this._score = 2;
                break;
            case 4 : 
                this._sprite = Assets.getSpriteFromJson('hotdog'); 
                this._walkingIndex = 11;
                this._score = 2;
                break;  
        }

       
        this._tween = TweenMax.to(this._sprite, this._speed, {x: 0 - this._game.screenWidth - this._sprite.width,  ease: Linear.easeNone,
            //onUpdate: this._onUpdate,
            onComplete: this._reachEnd
        });

        /*
        let graphic:PIXI.Graphics = new PIXI.Graphics();
        // this sets the fill colour
        graphic.lineStyle(2, 0xFF0000);
        // draw the square (x, y, width, height)
        if (this._foodNumber == 3) graphic.drawRect(this._sprite.width / 4.5, this._sprite.height / 7, this._sprite.width / 1.9, this._sprite.height / 1.5);
        graphic.endFill();
        this._sprite.addChild(graphic);
        */
        
        this._container = new PIXI.Container();
        this._container.addChild(this._sprite);
        this._sprite.pivot.y = this._sprite.height;
        this._sprite.loop = true;
        this._sprite.interactive = true;
        if (this._foodNumber == 1) this._sprite.hitArea = new PIXI.Rectangle(this._sprite.width / 3.7, this._sprite.height / 7, this._sprite.width / 2.3, this._sprite.height / 1.5);
        if (this._foodNumber == 2) this._sprite.hitArea = new PIXI.Rectangle(this._sprite.width / 4.5, this._sprite.height / 7, this._sprite.width / 1.9, this._sprite.height / 1.5);
        if (this._foodNumber == 3) this._sprite.hitArea = new PIXI.Rectangle(this._sprite.width / 4.5, this._sprite.height / 7, this._sprite.width / 1.9, this._sprite.height / 1.5);
        if (this._foodNumber == 4) this._sprite.hitArea = new PIXI.Rectangle(this._sprite.width / 3, this._sprite.height / 15, this._sprite.width / 2.3, this._sprite.height / 1.3);
        
        this._sprite.on(GameEvent.CLICK, this._onClickSprite, this);
        this._sprite.on(GameEvent.TAP, this._onClickSprite, this);
        this._sprite.play();

        this._sprite.onFrameChange = function(frame) {
            if (frame >= this._walkingIndex) this._sprite.gotoAndPlay(0);
        }.bind(this);

        let ratio = .95;
        if (window.devicePixelRatio > 1) { ratio = this._game.screenWidth / 275; } 

        this._container.scale.x = ratio;
        this._container.scale.y = ratio;

        if (sound == 1) {
            Assets.sounds['walk' + NumberUtils.random(1, 5)].play();
            Assets.sounds['food' + NumberUtils.random(1, 7)].play();
        }
        else if (sound % 3 == 0) Assets.sounds['food' + NumberUtils.random(1, 7)].play();
        else Assets.sounds['walk' + NumberUtils.random(1, 5)].play() ;
    };


    @autobind
    private _onClickSprite(e) {
        if(!this._clicked) {
            e.stopPropagation();
            this.dispatch({type:Food.CLICKED_FOOD}); 

            this._tween.kill();

            this._sprite.onFrameChange = function(frame) {
                undefined;
            }.bind(this)

            Assets.sounds['chop' + NumberUtils.random(1, 4)].play();
             
            this._sprite.gotoAndPlay(this._walkingIndex);
            this._sprite.loop = false;

            let onClickTween = TweenMax.to(this._sprite, 0.4, {y: 100, alpha: 0, ease: Linear.easeNone,
                //onUpdate: this._onUpdate,
                onComplete: this._delete
            });
            this._clicked = true;
        }
    }


    @autobind
    private _reachEnd() {
        this.dispatch({type:Food.LIMIT_FOOD});
        this._delete();
    }


    @autobind
    private _delete() {
        this._container.removeChild(this._sprite); 
        this._game.foodContainer.removeChild(this._container); 
    }

    public get container(): PIXI.Container {
        return this._container;
    }

    public get score() : number {
        return this._score;
    }
}